import { createSlice } from '@reduxjs/toolkit';
import { ICallLimitHistory } from '../types';

interface CallLimitState {
  data: ICallLimitHistory[];
  pages: {
    pageNo: number;
    totalPages: number;
    pageSize: number;
    totalElements: number;
  };
}

const initialState: CallLimitState = {
  data: [],
  pages: {
    pageNo: 1,
    totalPages: 1,
    pageSize: 10,
    totalElements: 0
  }
};

const callLimitSlice = createSlice({
  name: 'callLimit',
  initialState,
  reducers: {
    setCallLimitHistory(state, action) {
      return action.payload;
    },
    resetCallLimitState() {
      return initialState;
    }
  }
});

export const { setCallLimitHistory, resetCallLimitState } = callLimitSlice.actions;
export default callLimitSlice.reducer;
